import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BudgetCategory } from '../../../models/budget-category.model';
import { BudgetService } from '../../../services/budget.service';
import { ToastService } from 'src/app/shared/toasts/toast-service';
import { ItenGroupService } from '../../../services/iten-group.service';
import { ItembudgetCategory } from '../../../models/item-budget-category.model';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-budget-item-create-modal',
  templateUrl: './budget-item-create-modal.component.html',
  styleUrl: './budget-item-create-modal.component.scss'
})
export class BudgetItemCreateModalComponent implements OnInit {
  loading: boolean = false;

  groups: BudgetCategory[] = []

  itemForm!: FormGroup

  constructor(
    private fb: FormBuilder,
    public budgetService: BudgetService,
    private toastService: ToastService,
    private itenGroupService: ItenGroupService,
    public activeModal: NgbActiveModal,
  ) {}
  
  ngOnInit(): void {
    this.itemForm = this.fb.group({
      grupoId: ["", [Validators.required]],
      nome: ["", [Validators.required]],
      valor: ["", [Validators.required]],
      metroQuadrado: [""],
      metroQuadradoAdicional: [""]
    })

    this.loading = true;
    this.budgetService.getGroups().subscribe({
      next: (response) => {
        this.groups = response
      },
      error: (error) => {
        console.error('Erro ao buscar categorias:', error);
        this.toastService.show("Erro ao carregar categorias", {
          classname: "bg-danger text-light",
        });
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  get selectedGroup(): BudgetCategory | undefined {
    const grupoId = this.itemForm.get('grupoId')?.value;
    return this.groups.find(g => g.id === grupoId);
  }

  get isTipoCalculo3(): boolean {
    return this.selectedGroup?.tipoDeCalculo === 3;
  }

  onSubmit():void {
    if (this.itemForm.invalid) {
      this.itemForm.markAllAsTouched();
      return;
    }

    let item = new ItembudgetCategory();

    item.grupoId = this.itemForm.get('grupoId')?.value;
    item.nome = this.itemForm.get('nome')?.value || '';
    
    // Converter valor para number
    const valorValue = this.itemForm.get('valor')?.value;
    item.valor = valorValue ? parseFloat(String(valorValue)) : 0;
    
    // Converter metroQuadrado e metroQuadradoAdicional para number (sempre enviar, mesmo que seja 0)
    const metroQuadradoValue = this.itemForm.get('metroQuadrado')?.value;
    item.metroQuadrado = metroQuadradoValue !== undefined && metroQuadradoValue !== null && metroQuadradoValue !== '' 
      ? parseFloat(String(metroQuadradoValue)) 
      : 0;
    
    const metroQuadradoAdicionalValue = this.itemForm.get('metroQuadradoAdicional')?.value;
    item.metroQuadradoAdicional = metroQuadradoAdicionalValue !== undefined && metroQuadradoAdicionalValue !== null && metroQuadradoAdicionalValue !== '' 
      ? parseFloat(String(metroQuadradoAdicionalValue)) 
      : 0;

    this.loading = true;
    this.itenGroupService.createitem(item).subscribe({
      next: (response) =>  {
        this.toastService.show("Cadastrado com sucesso!", {
          classname: "bg-success text-light",
        });

        this.activeModal.close(true);
      },
      error: (error) =>  {
        this.toastService.show("Erro ao tentar cadastrar o item!", {
          classname: "bg-danger text-light",
        });
        console.error('Erro ao cadastrar item:', error);
      },
      complete: () => {
        this.loading = false;
      }
    })
  }
}

